import { Flex } from '@radix-ui/themes';
import { useMediaState } from '@vidstack/react';
import { PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from '../styles/SmartPlayer.module.css';

export const SmartPlayerToolbar = ({ children }: PropsWithChildren) => {
    const isPaused = useMediaState('paused');
    const controlsVisible = useMediaState('controlsVisible');
    const isVisible = isPaused || controlsVisible;

    return (
        <Flex
            direction='column'
            justify='end'
            gap='2'
            className={classNames(styles.toolbar)}
            style={{
                pointerEvents: isVisible ? 'auto' : 'none',
                opacity: isVisible ? 1 : 0,
            }}
        >
            {children}
        </Flex>
    );
};
